import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "40",
      height: "28",
      rx: "2",
      fill: "#222"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.388 19.503h-6.125V8.496h6.125v11.007Z",
      fill: "#7673C0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.651 14a6.988 6.988 0 0 1 2.674-5.503A7 7 0 0 0 9 14a7 7 0 0 0 11.325 5.503A6.988 6.988 0 0 1 17.65 14Z",
      fill: "#EB001B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.65 14a7 7 0 0 1-11.325 5.503A6.987 6.987 0 0 0 22.999 14a6.987 6.987 0 0 0-2.674-5.503A7 7 0 0 1 31.65 14",
      fill: "#00A1DF"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "maestro"}) } }